import { observer } from 'mobx-react';
import React from 'react';
import styled, { css } from 'styled-components';

import FiltersGroup from './FiltersGroup';
import NewDropdown from './NewDropdown';
import SelectionGroup from './SelectionGroup';

const Container = styled.div<{ $disabled: boolean }>`
  align-items: center;
  border-bottom: 1px solid #f2ebeb;
  border-top: 1px solid #f2ebeb;
  display: flex;
  height: 100%;
  justify-content: space-between;
  padding: 0 7px;
  width: 100%;

  ${(p) =>
    p.$disabled
      ? css`
          opacity: 0.5;
          pointer-events: none;
        `
      : null}
`;

const LeftContainer = styled.div`
  display: flex;
  gap: 5px;
`;

export interface CreativeAdListToolbarProps {
  disabled?: boolean;
}

function CreativeAdListToolbar({ disabled }: CreativeAdListToolbarProps) {
  return (
    <Container $disabled={!!disabled} data-testid="CreativeAdListToolbar">
      <LeftContainer>
        <SelectionGroup />
        <NewDropdown />
      </LeftContainer>

      <FiltersGroup />
    </Container>
  );
}

export default observer(CreativeAdListToolbar);
